import React, {Component} from 'react';
import './spread-table.css';
import ArrowDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import ArrowUp from 'material-ui/svg-icons/navigation/arrow-drop-up';
import ArrowRight from 'material-ui/svg-icons/av/play-arrow';
import moment from 'moment';
/**
 * @author chargoyao
 * @property tableHeaderArr {array} table header array.
 * [{label: 'ClientName', value: 'ClientName'}]
 * @property renderCols {obj} render data column
 * {
 *  addedCol: 'xxx',
 *  cols: ['xxx', 'xxxx']
 * }
 *
 * @property bodyDataArr {array} remote data
 * [{
 *  clientName: 'Deluth Trading',
 *  bizUnitName: 'Monsanto',
 *  deploymentType: 'WebProperty',
 *  domain: 'www.abc.com',
 *  uuid: 291923-11,
 *  activeStatus: Inactive
 *  }, {
 *    clientName: 'Deluth Trading',
 *    bizUnitName: 'Monsanto',
 *    deploymentType: 'WebProperty',
 *    domain: 'www.abc.com',
 *    uuid: 291923-11,
 *    activeStatus: Inactive
 *    children: [
 *    ]
 *  }]
 *  @property tableHeaderWidthStyle {array} table Width style
 *  ['22%', '12%']
 */
const arrowStyles = {
  position: 'absolute',
  right: 0,
  top: 0
}
class SpreadTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      activeIndex: 0,
      arrowActive: 'down'
    }
  }
  componentDidMount () {
  }
  handleClick (label, index) {
    this.setState({
      activeIndex: index
    });
    if (+index === this.state.activeIndex) {
      if (this.state.arrowActive === 'down') {
        this.setState({
          arrowActive: 'up'
        })
      } else {
        this.setState({
          arrowActive: 'down'
        })
      }
    } else {
      this.setState({
        arrowActive: 'down'
      })
    }
    if (index === 0) {
      this.props.handleSortByClientName()
    }
  }
  spreadTr (index) {
    if (this.state[`spread${index}`]) {
      this.setState({
        [`spread${index}`]: false
      })
    } else {
      this.setState({
        [`spread${index}`]: true
      });
    }
  }
  render () {
    return (
      <div className="spread-table">
        <table>
          <tbody>
            <tr>
              {this.props.tableHeaderArr.map((item, index) => {
                let widthStyle = '';
                switch (index) {
                  case 0:
                    widthStyle = this.props.tableHeaderWidthStyle[0];
                    break;
                  case 1:
                    widthStyle = this.props.tableHeaderWidthStyle[1];
                    break;
                  case 2:
                    widthStyle = this.props.tableHeaderWidthStyle[2];
                    break;
                  case 3:
                    widthStyle = this.props.tableHeaderWidthStyle[3];
                    break;
                  case 4:
                    widthStyle = this.props.tableHeaderWidthStyle[4];
                    break
                  default:
                    widthStyle = '';
                    break;
                }
                return (
                  <th key={item.value}
                      className={this.state.activeIndex === index && index === 0 ? 'active' : ''}
                      onClick={() => {if (item.label === 'Client Name') this.handleClick(item.label, index)}}
                      style={{width: widthStyle}}
                  >
                    {item.label}
                    {
                      (
                        this.state.activeIndex === index &&
                        this.state.arrowActive === 'down' &&
                        index === 0
                      ) && (
                        <ArrowDown
                          style={{
                            ...arrowStyles
                          }}
                        />
                      )
                    }
                    {
                      (
                        this.state.activeIndex === index &&
                        this.state.arrowActive === 'up' &&
                        index === 0
                      ) && (
                        <ArrowUp
                          style={{
                            ...arrowStyles
                          }}
                        />
                      )
                    }
                  </th>
                )
              })}
            </tr>
            {
              this.props.bodyDataArr.map((item, index) => {
              if (!item.children) {
                return (
                  <tr key={index}>
                    {
                      this.props.renderCols.cols.map((list, idx) => {
                        if (list === 'uuid') {
                          return (
                            <td className="uuid" key="uuid-n">
                              {item[list].substring(0,6) + '...'}
                              <div>
                                {item[list]}
                              </div>
                            </td>
                          )
                        } else if (list === 'industry') {
                          return (
                            <td key="industry-n">
                              {
                                item[list]['name']
                              }
                            </td>
                          )
                        } else if (list === 'createdTime') {
                          return (
                            <td key="createdTime-n">
                              {
                                moment(item[list]).format('M/DD/YY')
                              }
                            </td>
                          )
                        } else {
                          return (
                            <td key={`${idx}-addCol`} style={{paddingLeft: idx === 0 ? 0 : ''}}>
                              {item[list] || (this.props.renderCols.addCol.length > 0 && item[this.props.renderCols.addCol]) }
                            </td>
                          )
                        }

                      })
                    }
                  </tr>
                )
              } else {
                let obj  = [];
                if (item.children.length >= 1){
                  obj.push(
                    <tr key={index} onClick={() => this.spreadTr(index)}>
                      <td style={{paddingLeft: '20px', cursor: 'pointer'}}>
                        {
                          this.state[`spread${index}`] ? (
                            <ArrowDown
                              style={{position: 'absolute', left: '-7px', top: '2px'}}
                            />
                          ) : (
                            <ArrowRight
                              style={{position: 'absolute', left: '-5px', top: '6px', width: '16px', height: '16px'}}
                            />
                          )
                        }{item.clientName}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.bizUnitName}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.industry.name}
                      </td>
                      {/*<td style={{cursor: 'pointer'}}>*/}
                        {/*{ item.accountManager.firstName } { item.accountManager.lastName }*/}
                      {/*</td>*/}
                      <td style={{cursor: 'pointer'}}>
                        {moment(item.createdTime).format('M/DD/YY')}
                      </td>
                      <td style={{cursor: 'pointer'}}>
                        {item.status}
                      </td>
                      {/*<td style={{cursor: 'pointer'}}>*/}
                        {/*{moment(item.subscriptionTierStartTime).format('M/DD/YY')}*/}
                      {/*</td>*/}
                    </tr>
                  );
                }
                for(let [_, v] of item.children.entries()) {
                  obj.push(
                    <tr style={{display: this.state[`spread${index}`] ? 'table-row' : 'none'}}>
                      {
                        this.props.renderCols.cols.map((list, index) => {
                          if (list === 'uuid') {
                            return (
                              <td className="uuid" key="uuid-c">
                                {v[list].substring(0,6) + '...'}
                                <div>
                                {v[list]}
                                </div>
                              </td>
                            )
                          } else if (list === 'industry') {
                            return (
                              <td key="industry-c">
                                {
                                  v[list]['name']
                                }
                              </td>
                            )
                          } else if (list === 'createdTime') {
                            return (
                              <td key="createdTime-c">
                                {
                                  moment(v[list]).format('M/DD/YY')
                                }
                              </td>
                            )
                          } else {
                            return (
                              <td style={{paddingLeft: index === 0 ? '49px': ''}} key={`${v[list]}${index}`}>
                                {v[list] || (this.props.renderCols.addCol.length > 0 && v[this.props.renderCols.addCol]) }
                              </td>
                            )
                          }
                        })
                      }
                    </tr>
                  )
                }

                return obj;
              }
            })}
          </tbody>

        </table>
      </div>
    )
  }
}

SpreadTable.defaultProps = {
  tableHeaderWidthStyle: ['22%', '22%', '10%', '20%'],
  bodyDataArr: [],
  renderCols: {
    addCol: '',
    cols: []
  }
}

export default SpreadTable;



// WEBPACK FOOTER //
// ./src/components/ClientBusinessInfoAndUser/ClientBusiness/Table/Index.jsx